import {
  ApolloClient,
  InMemoryCache,
  createHttpLink
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import Mutation from './mutations';
import configurator from './configuratorState';
import appHandlers from '../utils/appHandlers';
import { ENABLE_NEW_CONFIGURATOR } from 'client/settings';

/*
  Get the current region from the URL

  Supports:
    dev-web-cn.ffau.to
    faradayfuturecn.com
    localhost:xxxx/cn/
*/
const region = /(-cn.ffau.to|faradayfuturecn.com|(:[\d]{4,5}|.to|.com)\/cn)/.test(window?.location?.href) ? 'CN' : 'US';

const isV3 = /^\/(us|cn)\/design/.test(window?.location?.pathname);

let source = 'Web';

if (appHandlers.isMobile()) {
  source = appHandlers.isAndroid() ? 'Android' : 'iOS';
}

let headers = { region, source };

if (ENABLE_NEW_CONFIGURATOR && isV3) {
  headers = {
    ...headers,
    'order-version': '3',
    'customer-version': '2',
    'configuration-version': '2',
    'referral-version': '2',
  };
}

// Determine if the current window location is on the US domain
const isUSDomain = /ff\.com/.test(window?.location?.host) && !/faradayfuturecn\.com/.test(window?.location?.host);

// Fix cross-domain issues by using the same domain for GraphQL requests
let graphqlDomain = window._env_.REACT_APP_GRAPHQL_DOMAIN || '';

// If we're on FF.com but the GraphQL domain is set to faradayfuturecn.com,
// override it to use the same domain as the current page
if (isUSDomain && graphqlDomain.includes('faradayfuturecn.com')) {
  // Use the current domain instead of the CN domain
  graphqlDomain = window.location.origin;
}


const httpLink = createHttpLink({
  uri: `${graphqlDomain}/graphql`,
});

const authLink = setContext((_, { headers: existingHeaders }) => {
  return {
    headers: {
      ...existingHeaders,
      ...headers
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  clientState: {
    defaults: {
      configurator
    },
    resolvers: {
      // Mutation is capitalized
      Mutation
    }
  },
});

export default client;
